<template>
  <l-map
    ref="map"
    style="position: relative; font-size:18px; height:900px; width: 100%; background-color:rgba(0, 0, 0, 0); color:#ffffff; z-index: 0;"
    :crs="crs"
    :min-zoom="minZoom4"
    :zoom="-1"
    :options="{scrollWheelZoom:false, zoomControl: false, doubleClickZoom: false, attributionControl:false,
               touchZoom: false, tap: false, dragging: false}"
  >
    <l-image-overlay
      :url="require('@/assets/images/icons/semcontrol/0STW-1MCB-1PW-1MC-2CB-1TFM-2W/diagram.png')"
      :bounds="bounds4"
    />
    <!-- Volt -->
    <l-marker
      :lat-lng="[600, 600]"
    >
      <l-icon
        class-name="someExtraClass"
      >
        <p class="headline nowrap">
          <span class="title">Volt</span>
          <span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{{ items.volt }}</span>
          <br><br>
          <span class="title">Amp</span>
          <span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{{ items.amp }}</span>
          <br><br>
          <span class="title">Watt</span>
          <span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{{ items.watt }}</span>
          <br><br>
          <!-- <span class="title">Pf</span>
          <span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{{ items.pf }}</span>
          <br><br> -->
          <span class="title">kWh</span>
          <span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{{ items.kwh }}</span>
          <br><br>
          <span class="title">Hz</span>
          <span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{{ items.hz }}</span>
        </p>
      </l-icon>
    </l-marker>
    <!-- ไฟจากการไฟฟ้า ----------------------------------------------------------->
    <l-marker
      v-if="items.c_other === '0'"
      :lat-lng="[740, -248]"
      :icon="iconTranformerF"
    />
    <l-marker
      v-else
      :lat-lng="[740, -248]"
      :icon="iconTranformerN"
    />
    <!-- MCB ----------------------------------------------------------->
    <l-marker
      v-if="(items.c_other === '0' || items.c_main_breaker === '0')"
      :lat-lng="[48, 88]"
      :icon="iconMCBF"
    />
    <l-marker
      v-else
      :lat-lng="[48, 88]"
      :icon="iconMCBN"
    />
    <!-- photo swicth ----------------------------------------------------------->
    <l-marker
      v-if="items.c_photo_switch === '0'"
      :lat-lng="[37, -319]"
      :icon="iconPhoto4"
    />
    <l-marker
      v-else
      :lat-lng="[37, -319]"
      :icon="iconPhotoMoon"
    />
    <!-- MC ----------------------------------------------------------->
    <l-marker
      v-if="(items.c_other === '0' || items.c_main_breaker === '0' || items.c_magnetic_contactor1 === '0')"
      :lat-lng="[-264, 3 ]"
      :icon="icon2MCF"
    />
    <l-marker
      v-else
      :lat-lng="[-264, 3 ]"
      :icon="icon2MCN"
    />
    <!-- CB1 iot4g ----------------------------------------------------------->
    <div>
      <l-marker
        v-if="(items.c_other === '0' || items.c_main_breaker === '0' || items.c_magnetic_contactor1 === '0' || items.c_sub_breaker1 === '0') && (items.line_detect1 === 1 && items.line_detect2 === 1)"
        :lat-lng="[-490, -360]"
        :icon="icon2CB1F"
      />
      <l-marker
        v-else-if="(items.c_sub_breaker1 === '1') && (items.line_detect1 === 0 || items.line_detect2 === 0)"
        :lat-lng="[-490, -360]"
        :icon="icon2CB1NB"
      />
      <l-marker
        v-else-if="(items.c_sub_breaker1 === '0') && (items.line_detect1 === 0 || items.line_detect2 === 0)"
        :lat-lng="[-470, -350]"
        :icon="icon2CB1FB"
      />
      <l-marker
        v-else-if="(items.c_magnetic_contactor1 === '1') && (items.line_detect1 === 1 && items.line_detect2 === 1)"
        :lat-lng="[-490, -360]"
        :icon="icon2CB1N"
      />
    </div>
    <!-- CB2 iot4g ----------------------------------------------------------->
    <div>
      <l-marker
        v-if="(items.c_other === '0' || items.c_main_breaker === '0' || items.c_magnetic_contactor1 === '0' || items.c_sub_breaker2 === '0') && (items.line_detect3 === 1 && items.line_detect4 === 1)"
        :lat-lng="[-488, 140]"
        :icon="icon2CB2F"
      />
      <l-marker
        v-else-if="(items.c_magnetic_contactor1 === '1' && items.c_sub_breaker2 === '1') && (items.line_detect3 === 1 && items.line_detect4 === 1)"
        :lat-lng="[-488, 140]"
        :icon="icon2CB2N"
      />
      <l-marker
        v-else-if="items.c_sub_breaker2 === '1' && (items.line_detect3 === 0 || items.line_detect4 === 0)"
        :lat-lng="[-488, 140]"
        :icon="icon2CB2NB"
      />
      <l-marker
        v-else-if="items.c_sub_breaker2 === '0' && (items.line_detect3 === 0 || items.line_detect4 === 0)"
        :lat-lng="[-482, 85]"
        :icon="icon2CB2FB"
      />
    </div>
  </l-map>
</template>

<script>
/* eslint-disable global-require */
import {
  LMap, LImageOverlay,
  LMarker,
  LIcon,
} from 'vue2-leaflet'
import { CRS, icon, Icon } from 'leaflet'
import 'leaflet/dist/leaflet.css'
import axios from '@axios'
// eslint-disable-next-line no-underscore-dangle
delete Icon.Default.prototype._getIconUrl
Icon.Default.mergeOptions({
  iconRetinaUrl: require('leaflet/dist/images/marker-icon-2x.png'),
  iconUrl: require('leaflet/dist/images/marker-icon.png'),
  shadowUrl: require('leaflet/dist/images/marker-shadow.png'),
})
/* eslint-disable global-require */

export default {
  components: {
    LMap,
    LImageOverlay,
    LMarker,
    LIcon,
  },
  data() {
    return {
      waydetail: '',
      checkLeft1: '',
      checkRight1: '',
      checkLeft2: '',
      checkRight2: '',
      bounds4: [[-900, 950], [950, -700]],
      iconSize: 64,
      crs: CRS.Simple,
      minZoom4: -1,
      deptid: '',
      markers: [],
      items: [],
      iconTranformerF: icon({
        iconUrl: require('@/assets/images/icons/semcontrol/0STW-1MCB-1PW-1MC-2CB-1TFM-2W/TFM-F.gif'),
        iconSize: [393, 355],
        iconAnchor: [16, 37],
      }),
      iconTranformerN: icon({
        iconUrl: require('@/assets/images/icons/semcontrol/0STW-1MCB-1PW-1MC-2CB-1TFM-2W/TFM-N.gif'),
        iconSize: [393, 355],
        iconAnchor: [16, 37],
      }),
      iconSSN: icon({
        iconUrl: require('@/assets/images/icons/semcontrol/diagram/SFSW-IN-ON-1.gif'),
        iconSize: [140, 270],
        iconAnchor: [16, 37],
      }),
      iconSSF: icon({
        iconUrl: require('@/assets/images/icons/semcontrol/diagram/SFSW-Off-ON-1.gif'),
        iconSize: [140, 270],
        iconAnchor: [16, 37],
      }),
      iconMCBF: icon({
        iconUrl: require('@/assets/images/icons/semcontrol/diagram/MCB-Off.gif'),
        iconSize: [60, 164],
        iconAnchor: [16, 37],
      }),
      iconMCBN: icon({
        iconUrl: require('@/assets/images/icons/semcontrol/diagram/MCB-On.gif'),
        iconSize: [60, 164],
        iconAnchor: [16, 37],
      }),
      iconSelect: icon({
        iconUrl: require('@/assets/images/icons/semcontrol/diagram/handswitchred.svg'),
        iconSize: [74, 74],
        iconAnchor: [16, 37],
      }),
      iconPhoto4: icon({
        iconUrl: require('@/assets/images/icons/semcontrol/diagram/Photo-DR.gif'),
        iconSize: [220, 179],
        iconAnchor: [16, 37],
      }),
      iconPhotoMoon: icon({
        iconUrl: require('@/assets/images/icons/semcontrol/diagram/Photo-N.gif'),
        iconSize: [220, 179],
        iconAnchor: [16, 37],
      }),
      icon2MCN: icon({
        iconUrl: require('@/assets/images/icons/semcontrol/1STW-1MCB-1PW-1MC-2CB-1TFM/M-ON-1.gif'),
        iconSize: [143, 190],
        iconAnchor: [16, 37],
      }),
      icon2MCF: icon({
        iconUrl: require('@/assets/images/icons/semcontrol/1STW-1MCB-1PW-1MC-2CB-1TFM/M-OFF-1.gif'),
        iconSize: [143, 190],
        iconAnchor: [16, 37],
      }),
      icon2CB1N: icon({
        iconUrl: require('@/assets/images/icons/semcontrol/1STW-1MCB-1PW-1MC-2CB-1TFM/CB1-On-1.gif'),
        iconSize: [245, 243],
        iconAnchor: [16, 37],
      }),
      icon2CB1F: icon({
        iconUrl: require('@/assets/images/icons/semcontrol/1STW-1MCB-1PW-1MC-2CB-1TFM/CB1-Off-1.gif'),
        iconSize: [245, 243],
        iconAnchor: [16, 37],
      }),
      icon2CB1NB: icon({
        iconUrl: require('@/assets/images/icons/semcontrol/1STW-1MCB-1PW-1MC-2CB-1TFM/CB1-L1-B.gif'),
        iconSize: [245, 243],
        iconAnchor: [16, 37],
      }),
      icon2CB1FB: icon({
        iconUrl: require('@/assets/images/icons/semcontrol/1STW-1MCB-1PW-1MC-2CB-1TFM/CB1-L1-A.gif'),
        iconSize: [295, 260],
        iconAnchor: [16, 37],
      }),
      icon2CB2N: icon({
        iconUrl: require('@/assets/images/icons/semcontrol/1STW-1MCB-1PW-1MC-2CB-1TFM/CB2-On-1.gif'),
        iconSize: [243, 243],
        iconAnchor: [16, 37],
      }),
      icon2CB2F: icon({
        iconUrl: require('@/assets/images/icons/semcontrol/1STW-1MCB-1PW-1MC-2CB-1TFM/CB2-Off-1.gif'),
        iconSize: [243, 243],
        iconAnchor: [16, 37],
      }),
      icon2CB2NB: icon({
        iconUrl: require('@/assets/images/icons/semcontrol/1STW-1MCB-1PW-1MC-2CB-1TFM/CB2-L1-B.gif'),
        iconSize: [243, 243],
        iconAnchor: [16, 37],
      }),
      icon2CB2FB: icon({
        iconUrl: require('@/assets/images/icons/semcontrol/1STW-1MCB-1PW-1MC-2CB-1TFM/CB2-L1-A.gif'),
        iconSize: [297, 260],
        iconAnchor: [16, 37],
      }),
      sem_type: '',
      diagram_type: '',
      type: '',
    }
  },
  beforeDestroy() {
    clearInterval(this.interval)
  },
  created() {
    this.checkLine()
    this.getCenterSem()
    this.getValueDiagram()
    this.interval = setInterval(() => {
      this.getValueDiagram()
      this.getCenterSem()
      this.checkLine()
    }, 10000)
  },
  mounted() {
    this.$refs.map.mapObject.invalidateSize()
    this.type = this.$route.query.type
  },
  methods: {
    checkLine() {
      axios.post('/checkLine', { wid: this.$route.query.wid })
        .then(response => {
          // eslint-disable-next-line prefer-destructuring
          this.check = response.data[0]
          if (this.check.line_detect1 === 'OK') {
            this.checkLeft1 = true
          } else {
            this.checkLeft1 = false
          }
          if (this.check.line_detect2 === 'OK') {
            this.checkLeft2 = true
          } else {
            this.checkLeft2 = false
          }
          if (this.check.line_detect3 === 'OK') {
            this.checkRight1 = true
          } else {
            this.checkRight1 = false
          }
          if (this.check.line_detect4 === 'OK') {
            this.checkRight2 = true
          } else {
            this.checkRight2 = false
          }
        })
        .catch(error => {
          console.log(error)
        })
    },
    getCenterSem() {
      axios
        .post('/waySEMControlDetail', { wid: this.$route.query.wid })
        .then(response => {
          this.center = []
          this.waydetail = response.data[0].detail
          this.deptid = response.data[0].deptid
          this.type_name = response.data[0].type_name
          this.switch.semid = response.data[0].id
        })
        .catch(error => {
          console.log(error)
        })
    },
    getValueDiagram() {
      axios
        .post('/valueDiagram', { wid: this.$route.query.wid })
        .then(response => {
          this.sem_type = response.data[0].firmware
          this.diagram_type = response.data[0].diagram_type
          // eslint-disable-next-line prefer-destructuring
          this.items = response.data[0]
        })
        .catch(error => {
          console.log(error)
        })
    },
  },
}
</script>
<style  lang="scss" scoped>
.headline {
  font-size: 20px;
}
.title {
  color:#FFFFD5
}
.nowrap {
  white-space: nowrap ;
}
</style>
